import template from './upload_general_document.html';
import tr from '../../lib/default-translator.js';

class GeneralDocumentUploadViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.doc_types = ko.observableArray();
		this.new_name = ko.observable('');
		this.note = ko.observable('');
		this.selected_type_id = ko.observable();
		this.access_roles = ko.observableArray();
		this.default_viewing_role = ko.observableArray(['admin']);
		this.exceed_size = ko.observable(false);

			this.selected_type_id.subscribe(async (value) => {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'general_document_types',
				schema: 'public',
				limit: 1,
				filter: [{ value: value, op: '=', field: 'general_document_type_id' }]
			});
			if (res)
				this.default_viewing_role(res.records[0].default_viewing_roles);
			else
				this.default_viewing_role.removeAll();
		});
	}

	close()
	{
		this.dialog.close();
	}

	before_upload(formData)
	{
		if (document.getElementsByName('document')[0].files[0])
		{
			if (document.getElementsByName('document')[0].files[0].size > 20000000)
			{
				formData.append('abort_upload', 'true');// abort the upload on the API side
				formData.append('problem', tr('File size exceeds the maximum limit of 20MB')); 
				$('#upload_input').val('');
				$('#upload_btn').button('reset');
				this.exceed_size(true);
				return;
			}
		}

		if (!this.default_viewing_role())
		{
			formData.append('abort_upload', 'true'); // abort the upload on the API side
			formData.append('problem', tr('Cannot save without any access rights selected.'));
		}

		formData.append('doc_type', this.selected_type_id());
		formData.append('viewing_roles', this.default_viewing_role());
		formData.append('problem', 'Could not upload this file.');

		if (this.new_name() == null || this.new_name() == '')
			formData.append('name', this.selected_type_id() + '_document');
		else
			formData.append('name', this.new_name());

		formData.append('note', this.note());
	}

	async after_upload(responseObject)
	{
		if (responseObject.status == 'ERROR')
		{
			if (this.exceed_size())
				return;
			//else
			//	await Grape.alerts.alert({ type: 'warning', message: responseObject.message, title: tr('Error') });
		}
		else if (responseObject.status == 'OK')
		{
			Grape.alerts.alert({ type: 'success', message: tr('Successfully uploaded file'), title: tr('Success') });
			$('#upload_input').val('');
			$('#upload_btn').button('reset');
			this.dialog.close();
		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong'), title: tr('Error') });

		this.exceed_size(false);
	}
}

class GeneralDocumentUploadPage
{
	constructor (bindings)
	{
		this.viewModel = new GeneralDocumentUploadViewModel(this);
		this.bindings = bindings;
	}

	async load()
	{
		autocomplete(document.getElementById('txtDescription'), window.global_AutoComplete_Dictionary_Documents);
		autocomplete(document.getElementById('txtNote'), window.global_AutoComplete_Dictionary_Documents);

		  // Get document types and sort them with HR first
		let doc_types = await Grape.cache.get('GeneralDocumentTypes');

		if (doc_types && doc_types.length > 0)
		{
			doc_types = doc_types.sort((a, b) => {
				let a_type = a?.type || '';
				let b_type = b?.type || '';
				if (a_type === 'HR') return -1;
				if (b_type === 'HR') return 1;
				return a_type.localeCompare(b_type); // Sort other items alphabetically
			});
			
			this.viewModel.doc_types(doc_types);
			
			// If general_document_type_id was passed, use it as the default
			if (this.bindings.general_document_type_id)
				this.viewModel.selected_type_id(this.bindings.general_document_type_id);
			else if (doc_types[0])	
				this.viewModel.selected_type_id(doc_types[0].general_document_type_id);
		}


		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'access_role',
			schema: 'grape',
			sortfield: 'role_name',
			sortorder: 'asc',
			filter: [{
					value: ['guest', 'admin', 'manager', 'employee', 'accountant', 'general_manager', 'all', 'developer', 'director'],
					operand: 'IN',
					field: 'role_name'
				}]
		});

		this.viewModel.access_roles(res?.records || []);
	}

	init()
	{
		return this.load();
	}
};

export default {
	name: 'UploadGeneralDocument',
	dialog_class: GeneralDocumentUploadPage,
	template: template,
	template_filename: 'translation/dialogs/upload_general_document',
	provider: 'ps'
}
